import { RoutePaths } from 'types/enums';
import { Pack, Repack } from 'types/generated/graphql';

export function usePartner(item?: Pack | Repack) {
    if (item?.label?.slug) {
        return {
            route: RoutePaths.Labels,
            slug: item.label.slug,
        };
    }

    if (item?.artist?.slug) {
        return {
            route: RoutePaths.Artists,
            slug: item.artist.slug,
        };
    }

    return null;
}
